export type AutoCenterMode = 'spot' | 'king' | 'off';
export const DEFAULT_AUTO_CENTER_MODE: AutoCenterMode = 'spot';

interface PreferenceResponse {
  success: boolean;
  data?: {
    autoCenterMode: AutoCenterMode;
    devUserId: string;
  };
  error?: string;
}

export async function fetchAutoCenterModePreference(): Promise<AutoCenterMode> {
  const response = await fetch('/api/dev/preferences/auto-center');

  const json = (await response.json()) as PreferenceResponse;
  if (!response.ok || !json.success || json.data == null) {
    throw new Error(json.error ?? 'Failed to load auto-center preference');
  }

  return json.data.autoCenterMode;
}

export async function saveAutoCenterModePreference(mode: AutoCenterMode): Promise<void> {
  const response = await fetch('/api/dev/preferences/auto-center', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ autoCenterMode: mode }),
  });

  const json = (await response.json()) as PreferenceResponse;
  if (!response.ok || !json.success || json.data == null) {
    throw new Error(json.error ?? 'Failed to save auto-center preference');
  }
}
